import { C } from '../../MapSharedData';

interface Props {
  name: string;
  x: number;
  y: number;
}

export function SimpleRegionTooltip({ name, x, y }: Props) {
  return (
    <div
      className="fixed rounded-lg px-2.5 py-1.5 text-xs pointer-events-none z-[9999] shadow-popup"
      style={{ left: x + 14, top: y - 10, background: C.textPrimary, color: C.bg }}
    >
      {name}
    </div>
  );
}
